import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import FrontIndexModuleTypes from '@/store/modules/frontDesk/index/interface';

const frontIndexModule: Module<FrontIndexModuleTypes, RootModuleTypes> = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getCompany(context, params) {
      return new Promise((resolve, reject) => {
        tool.post('/frontend/index/anon/getCompany', params).then((data) => {
          if (data.status === 2000) {
            resolve(data);
          } else {
            reject(data);
          }
        });
      });
    },
    listDeveloperName(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listDeveloperName', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listActivity(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listActivity', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listBrandName(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listBrandName', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    listAdvertisingImage(context, searchParams) {
      return new Promise((resolve, reject) => {
        tool
          .post('/frontend/index/anon/listAdvertisingImage', searchParams)
          .then((data) => {
            if (data.status === 2000) {
              resolve(data);
            } else {
              reject(data);
            }
          });
      });
    },
    createWxPayOrder(context, params) {
      return new Promise((resolve, reject) => {
        tool.post('/weixinApi/createWxPayOrder', params).then((data) => {
          if (data.status === 2000) {
            resolve(data);
          } else {
            reject(data);
          }
        });
      });
    },
    listCanUseCoupons(context, params) {
      return new Promise((resolve, reject) => {
        tool.post('/weixinApi/listCanUseCoupons', params).then((data) => {
          if (data.status === 2000) {
            resolve(data);
          } else {
            reject(data);
          }
        });
      });
    },
  },
};

export default frontIndexModule;
